import ApexChart from "../Pages/Charts/Apexchart/ApexChart";
import ChartJs from "../Pages/Charts/ChartJs/ChartJs";
import GoogleChart from "../Pages/Charts/GoogleChart/GoogleChart";
import ButtonGroup from "../Pages/Buttons/ButtonGroup/ButtonGroup";
import DefaultStyle from "../Pages/Buttons/DefaultStyle/DefaultStyle";
import EdgeStyle from "../Pages/Buttons/EdgeStyle/EdgeStyle";
import FlatStyle from "../Pages/Buttons/FlatStyle/FlatStyle";
import RaisedStyle from "../Pages/Buttons/RaisedStyle/RaisedStyle";

import Default from "../Pages/Dashboard/Default/Default";
import Ecommerce from "../Pages/Dashboard/Ecommerce/Ecommerce";
import Charts from "../Pages/Widgets/Charts/Charts";
import General from "../Pages/Widgets/General/General";
import DatePicker from "../Pages/Forms/FormsWidgets/DatePicker/DatePicker";
import TouchSpin from "../Pages/Forms/FormsWidgets/TouchSpin/TouchSpin";
import MegaOption from "../Pages/Forms/FormsControl/MegaOption/MegaOption";
import InputGroup from "../Pages/Forms/FormsControl/InputGroup/InputGroup";
import InputMask from "../Pages/Forms/FormsControl/InputMask/InputMask";
import RadioCheckbox from "../Pages/Forms/FormsControl/RadioCheckbox/RadioCheckbox";
import BaseInput from "../Pages/Forms/FormsControl/BaseInput/BaseInput";
import FormsValidation from "../Pages/Forms/FormsControl/FormsValidation/FormsValidation";

import FeatherIcons from "../Pages/Icons/FeatherIcons";
import FlagIcons from "../Pages/Icons/FlagIcons";
import FontAwesomeIcon from "../Pages/Icons/FontAwesomeIcon";
import ICOIcon from "../Pages/Icons/ICOIcon";
import ThemifyIcons from "../Pages/Icons/ThemifyIcons";
import WhetherIcon from "../Pages/Icons/WhetherIcons";

import HideNavScrollContainer from "../Pages/PageLayout/HideNavScrollContainer/HideNavScrollContainer";
import FormWizardOne from "../Pages/Forms/FormsLayout/FormWizardOne/FormWizardOne";
import FormWizardTwo from "../Pages/Forms/FormsLayout/FormWizardTwo/FormWizardTwo";
import TwoFactor from "../Pages/Forms/FormsLayout/TwoFactor/TwoFactor";
import ClipBoard from "../Pages/Forms/FormsWidgets/ClipBoard/ClipBoard";
import Switch from "../Pages/Forms/FormsWidgets/Switch/Switch";
import Typeahead from "../Pages/Forms/FormsWidgets/Typeahead/Typeahead";

import SamplePage from "../Pages/SamplePage/SamplePage";
import ProjectList from "../Pages/Application/Project/ProjectList/ProjectList";
import ProjectCreate from "../Pages/Application/Project/ProjectCreate/ProjectCreate";
import FileManager from "../Pages/Application/FileManager/FileManager";
import LetterBox from "../Pages/Application/LetterBox/LetterBox";
import UsersProfile from "../Pages/Application/Users/UsersProfile/UsersProfile";
import EditProfile from "../Pages/Application/Users/EditProfile/EditProfile";
import UserCards from "../Pages/Application/Users/UserCards/UserCards";
import Todo from "../Pages/Application/Todo/Todo";
import Calender from "../Pages/Application/Calender/Calender";
import Tasks from "../Pages/Application/Tasks/Tasks";
import Contacts from "../Pages/Application/Contacts/Contacts";
import Bookmark from "../Pages/Application/Bookmark/Bookmark";
import SearchResult from "../Pages/Application/SearchResult/SearchResult";
import PrivateChat from "../Pages/Application/Chat/PrivateChat/PrivateChat";
import GroupChat from "../Pages/Application/Chat/GroupChat/GroupChat";
import SocialApp from "../Pages/Application/SocialApp/SocialApp";

import ProjectManagement from "../Pages/Dashboard/ProjectManagement/ProjectManagement";
import Identification from "../Pages/Application/Identification/Identification";
import StandCategory from "../Pages/Application/StandCategory/StandCategory";
import ExhibitionType from "../Pages/Application/ExhibitionType/ExhibitionType";
import Exhibition from "../Pages/Application/Exhibition/Exhibition";
import ExhibitionRelated from "../Pages/Application/ExhibitionRelated/ExhibitionRelated";
import ExhibitorTypePage from "../Pages/Application/ExhibitorType/ExhibitorType";
import ExhibitionStatisticsPage from "../Pages/Application/ExhibitionStatistics/ExhibitionStatistics";
import ExhibitorsPage from "../Pages/Application/Exhibitors/ExhibitorsPage";
import ExhibitorsRelatedPage from "../Pages/Application/ExhibitorsRelated/ExhibitorsRelatedPage";
import ExhibitorsAccessPage from "../Pages/Application/exhibitorsaccess/ExhibitorsAccessPage";
import PrintingPage from "../Pages/Application/PrintingPage/PrintingPage";
import PersonsPage from "../Pages/Application/PersonPage/person-page";
import RolePage from "../Pages/Application/rolemanagement/role-management";
import MenuPage from "../Pages/Application/menusmanagement/menu-page";
import RoleMenuPage from "../Pages/Application/rolemenupage/role-menu-page";
import UserRoleManagementPage from "../Pages/Application/userrole/user-role-page";

import BadgeRequestPage from "../Pages/Application/BadgeRequest/BadgeRequestPage";
import OrderVerificationPage from "../Pages/Application/OrderVerification/OrderVerificationPage";
import ExhibitorAccessManagementPage from "../Pages/Application/ExhibitorAccessManagementpage/ExhibitorAccessManagementPage";
import TurnStilePage from "../Pages/Application/TurnStilePage/TurnStilePage";
import TurnstileAssignmentPage from "../Pages/Application/TurnStileAssignmentPage/TurnStileAssignmentPage";
import BadgeEntryVerificationPage from "../Pages/Application/BadgeEntryVerificationPage/BadgeEntryVerificationPage";
import TicketingPage from "../Pages/Application/TicketingPage/TicketingPage";
import GateAssignmentPage from "../Pages/Application/GateAssignmentPage/GateAssignmentPage";
import VehicleVisitPage from "../Pages/Application/VehicleVisitPage/VehicleVisitPage";

import BadgeReportingPage from "../Pages/Application/badgeReportingPage/BadgeReportingPage";
import EntryReportingPage from "../Pages/Application/entryReportingPage/entryreportingPage";
import MyBadgeOrderPage from "../Pages/Application/myBadgeOrderPage/myBadgeOrderPage";
import ExhibitorstaffCarsPage from "../Pages/Application/staffCarsPage/StaffCarsPage";
import TicketPurchasePage from "../Pages/Application/PurchaseTicketPage/PurchaseTicketPage";

import PerformancePage from "../Pages/Application/PerformancePage/PerformancePage";

import AnalyticsPage from "../Pages/Application/AnalyticsPage/AnalyticsPage";


import { Component } from "react";






const Routes = [
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Default /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, Component: <Ecommerce /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/project`, Component: <ProjectManagement /> },

  // users
    { path: `${process.env.PUBLIC_URL}/users`, Component: <PersonsPage /> },
    { path: `${process.env.PUBLIC_URL}/user-role-management/:userId`, Component: <UserRoleManagementPage/>},

  // settings

  { path: `${process.env.PUBLIC_URL}/identification`, Component: <Identification /> },
  { path: `${process.env.PUBLIC_URL}/standcategory`, Component: <StandCategory /> },
  { path: `${process.env.PUBLIC_URL}/exhibitiontype`, Component: <ExhibitionType />},
  { path: `${process.env.PUBLIC_URL}/exhibitor-type`, Component: <ExhibitorTypePage /> },
  { path: `${process.env.PUBLIC_URL}/roles`, Component: <RolePage /> },
  { path: `${process.env.PUBLIC_URL}/menus`, Component: <MenuPage /> },
  { path: `${process.env.PUBLIC_URL}/role-management/:roleId/menus`, Component: <RoleMenuPage/>},
  { path: `${process.env.PUBLIC_URL}/turnstiles`, Component: <TurnStilePage/>},
  { path: `${process.env.PUBLIC_URL}/turnstile-assignments`, Component: <TurnstileAssignmentPage/>},


 


  // Application

  { path: `${process.env.PUBLIC_URL}/exhibition`, Component: <Exhibition /> },
  { path: `${process.env.PUBLIC_URL}/exhibition/:id/related`, Component: <ExhibitionRelated /> },
  { path: `${process.env.PUBLIC_URL}/exhibition-statistics`, Component: <ExhibitionStatisticsPage /> },

  { path: `${process.env.PUBLIC_URL}/exhibitors`, Component: <ExhibitorsPage /> },
  { path: `${process.env.PUBLIC_URL}/access-management`, Component: <ExhibitorAccessManagementPage /> },
  { path: `${process.env.PUBLIC_URL}/exhibitor/:id/related`, Component: <ExhibitorsRelatedPage /> },

  { path: `${process.env.PUBLIC_URL}/exhibitors-management`, Component: <ExhibitorsAccessPage /> },

  { path: `${process.env.PUBLIC_URL}/printing-badges`, Component: <PrintingPage />},
 
  { path: `${process.env.PUBLIC_URL}/badge-entries`, Component: <BadgeEntryVerificationPage/>},

  { path: `${process.env.PUBLIC_URL}/badge-requests`, Component: <BadgeRequestPage />},
  { path: `${process.env.PUBLIC_URL}/orders-verification`, Component: <OrderVerificationPage/>},

  { path: `${process.env.PUBLIC_URL}/performance`, Component: <PerformancePage/>},  


  { path: `${process.env.PUBLIC_URL}/ticketing`, Component: <TicketingPage/>},
  { path: `${process.env.PUBLIC_URL}/ticket-purchase`, Component: <TicketPurchasePage/>},

  { path: `${process.env.PUBLIC_URL}/gate-assignments`, Component: <GateAssignmentPage />},
  { path: `${process.env.PUBLIC_URL}/vehicle-visits`, Component: <VehicleVisitPage/>},

  { path: `${process.env.PUBLIC_URL}/badge-reporting`, Component: <BadgeReportingPage />},
  { path: `${process.env.PUBLIC_URL}/entry-reporting`, Component: <EntryReportingPage />},

  { path: `${process.env.PUBLIC_URL}/my-badge-orders`, Component: <MyBadgeOrderPage />},

  { path: `${process.env.PUBLIC_URL}/staff-cars`, Component: <ExhibitorstaffCarsPage />},
  { path: `${process.env.PUBLIC_URL}/analytics`, Component: <AnalyticsPage />},

  

  

  // Forms Widgets
  { path: `${process.env.PUBLIC_URL}/forms/formswidget/datepicker`, Component: <DatePicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/formswidget/touchspin`, Component: <TouchSpin /> },

  // Form Controls
  { path: `${process.env.PUBLIC_URL}/forms/formscontrols/megaoption`, Component: <MegaOption /> },
  { path: `${process.env.PUBLIC_URL}/forms/formscontrols/inputgroups`, Component: <InputGroup /> },
  { path: `${process.env.PUBLIC_URL}/forms/formscontrols/inputmask`, Component: <InputMask /> },
  { path: `${process.env.PUBLIC_URL}/forms/formscontrols/radiocheckbox`, Component: <RadioCheckbox /> },
  { path: `${process.env.PUBLIC_URL}/forms/formscontrols/formvalidation`, Component: <FormsValidation /> },
  { path: `${process.env.PUBLIC_URL}/forms/formscontrols/baseinput`, Component: <BaseInput /> },

 

  // Charts
  { path: `${process.env.PUBLIC_URL}/charts/apexchart`, Component: <ApexChart /> },
  { path: `${process.env.PUBLIC_URL}/charts/googlechart`, Component: <GoogleChart /> },
  { path: `${process.env.PUBLIC_URL}/charts/chartjschart`, Component: <ChartJs /> },

  // Buttons
  { path: `${process.env.PUBLIC_URL}/buttons/defaultstyle`, Component: <DefaultStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/flatstyle`, Component: <FlatStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/edgestyle`, Component: <EdgeStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/raisedstyle`, Component: <RaisedStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/buttongroup`, Component: <ButtonGroup /> },

  // Icons
  { path: `${process.env.PUBLIC_URL}/icons/flagicons`, Component: <FlagIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/fontawesomeicon`, Component: <FontAwesomeIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/icoicon`, Component: <ICOIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/themifyicon`, Component: <ThemifyIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/feathericon`, Component: <FeatherIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/wheathericon`, Component: <WhetherIcon /> },




  // Page Layout
  { path: `${process.env.PUBLIC_URL}/pagelayout/hidenavscroll`, Component: <HideNavScrollContainer /> },

  // Widgets
  { path: `${process.env.PUBLIC_URL}/widgets/general`, Component: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart`, Component: <Charts /> },

  // Form Widgets
  { path: `${process.env.PUBLIC_URL}/forms/formswidget/switch`, Component: <Switch /> },
  { path: `${process.env.PUBLIC_URL}/forms/formswidget/typeahead`, Component: <Typeahead /> },
  { path: `${process.env.PUBLIC_URL}/forms/formswidget/clipboard`, Component: <ClipBoard /> },

  // Form Layout
  { path: `${process.env.PUBLIC_URL}/forms/formslayout/formwizard1`, Component: <FormWizardOne /> },
  { path: `${process.env.PUBLIC_URL}/forms/formslayout/formwizard2`, Component: <FormWizardTwo /> },
  { path: `${process.env.PUBLIC_URL}/forms/formslayout/twofactor`, Component: <TwoFactor /> },

 
  // Sample Page
  { path: `${process.env.PUBLIC_URL}/pages/samplepage`, Component: <SamplePage /> },

  // Applications
  { path: `${process.env.PUBLIC_URL}/project/projectlist`, Component: <ProjectList /> },
  { path: `${process.env.PUBLIC_URL}/project/createnew`, Component: <ProjectCreate /> },

  // FileManager
  { path: `${process.env.PUBLIC_URL}/app/filemanager`, Component: <FileManager /> },

  // Email
  { path: `${process.env.PUBLIC_URL}/email/letterbox`, Component: <LetterBox /> },

  // Users
  { path: `${process.env.PUBLIC_URL}/users/useredit`, Component: <EditProfile /> },
  // { path: `${process.env.PUBLIC_URL}/users/useredit`, Component: <EditProfile /> },
  // // { path: `${process.env.PUBLIC_URL}/users/cards`, Component: <UserCards /> },

  // Todo
  { path: `${process.env.PUBLIC_URL}/app/todo`, Component: <Todo /> },

  // Calender
  { path: `${process.env.PUBLIC_URL}/app/calendar`, Component: <Calender /> },

  // Tasks
  { path: `${process.env.PUBLIC_URL}/app/task`, Component: <Tasks /> },

  // Contacts
  { path: `${process.env.PUBLIC_URL}/app/contacts`, Component: <Contacts /> },

  // Bookmark
  { path: `${process.env.PUBLIC_URL}/app/bookmark`, Component: <Bookmark /> },

  // Search Result
  { path: `${process.env.PUBLIC_URL}/app/searchresult`, Component: <SearchResult /> },

  // Chat
  { path: `${process.env.PUBLIC_URL}/chat/privatechats`, Component: <PrivateChat /> },
  { path: `${process.env.PUBLIC_URL}/chat/groupchat`, Component: <GroupChat /> },

  // Social App
  { path: `${process.env.PUBLIC_URL}/app/socialapp`, Component: <SocialApp /> },

  
];

export default Routes;
